import supabase from '@/lib/supabase';

export enum GemTransactionReason {
  LEARN_COMPLETE = 'learn_complete',
  TASK_REWARD = 'task_reward',
  EVENT_REWARD = 'event_reward',
  GIFT_CLAIM = 'gift_claim',
  DEBUG = 'debug',
  BUY_HEART_ONE = 'buy_heart_one',
  BUY_HEART_FILL = 'buy_heart_fill',
  BUY_GAME_TIME = 'buy_game_time',
  BUY_SPIN = 'buy_spin',
  BUY_OUTFIT = 'buy_outfit',
  BUY_FISH_AI = 'buy_fish_ai',
}

export interface GemTransactionParams {
  userId: string;
  type: 'earn' | 'spend';
  amount: number;
  reason: GemTransactionReason;
  balanceBefore: number;
  balanceAfter: number;
  metadata?: Record<string, unknown>;
}

const MAX_RETRIES = 3;

async function insertWithRetry(params: GemTransactionParams, attempt = 1): Promise<void> {
  const { error } = await supabase.from('gem_transactions').insert({
    user_id: params.userId,
    type: params.type,
    amount: params.amount,
    reason: params.reason,
    balance_before: params.balanceBefore,
    balance_after: params.balanceAfter,
    metadata: params.metadata ?? null,
  });

  if (error) {
    if (attempt < MAX_RETRIES) {
      await new Promise(resolve => setTimeout(resolve, 500 * attempt));
      return insertWithRetry(params, attempt + 1);
    }
    console.error(`[gem-logger] Failed after ${MAX_RETRIES} attempts:`, error);
  }
}

export function logGemTransaction(params: GemTransactionParams): void {
  insertWithRetry(params).catch(err => {
    console.error('[gem-logger] Unexpected error:', err);
  });
}
